<template>
  <div>
    <div class="newQuestionsBackground md:py-12 dark:bg-purple-600">
      <div class="buttonDiv">
        <BackButton />
        <h2 class="questionTitle dark:text-white">
          Which of the following do you do regularly to cope with stress? (select all that apply)
        </h2>
        <div data-aos="fade-left" class="checkboxes">
          <span v-for="(label, index) in labels" :key="index">
            <input
              type="checkbox"
              :id="idArr[index]"
              v-on:click="checkboxesChecked"
              name="coping[]"
              :checked="$store.state.views.questionTen.checkedButtons[index] === idArr[index]"
            />
            <label :for="idArr[index]" class="dark:text-white dark:bg-hero-purple">
              {{ label }}
            </label>
          </span>
        </div>
      </div>
    </div>

    <div class="alignFooter dark:bg-hero-purple border-b border-gray-200 dark:border-hero-purple">
      <div class="footerContainer">
        <HelpDialog />
        <button
          v-on:click="nextQuestion"
          v-if="isActive || $store.state.views.questionTen.nextButtonActive == true"
          class="nextButtonQuestions"
        >
          Next
          <span class="arrow">
            <svg
              width="14"
              height="12"
              viewBox="0 0 14 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                fill="#8380A8"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import BackButton from "./BackButton.vue";
import HelpDialog from "./HelpDialog.vue";

export default {
  data() {
    return {
      idArr: [
        "option1",
        "option2",
        "option3",
        "option4",
        "option5",
        "option6",
        "option7",
        "option8",
        "option9",
        "option10",
        "option11",
        "option12",
        "option13",
        "option14",
        "option15",
        "option16"
      ],
      labels: [
        "Exercise/play sports",
        "Socializing with friends",
        "Participate in clubs/societies",
        "Engage with a hobby",
        "Talk to a friend/family member/loved one",
        "Solo activities (drawing, reading, going for a walk, watching shows/movies)",
        "Turn to my faith",
        "Use substances (e.g., cannabis, alcohol, hallucinogens)",
        "Spend more time on social media",
        "Spend more time gaming",
        "Modify my eating",
        "Gamble",
        "Watch pornography",
        "Engage in high-risk or unsafe sexual activity",
        "Prefer not to answer",
        "None of the above"
      ],
      answerOptions: [
        "Exercise",
        "Socializing",
        "Clubs",
        "Hobby",
        "Talk",
        "Solo",
        "Faith",
        "Substance",
        "Social Media",
        "Gaming",
        "Eating Disorders",
        "Gambling",
        "Pornography",
        "Sexual Health",
        "NA",
        "None"
      ],
      isActive: false,
    };
  },

  components: { BackButton, HelpDialog },

  mounted: function () {
    this.scrollToTop();
    this.track();
  },

  methods: {
    track() {
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      if (!isDemo) {
        this.$gtag.pageview({ page_path: "step10" });
      } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
    },
    checkboxesChecked() {
      var checkboxes = document.getElementsByName("coping[]");
      var total = 0;

      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          total += 1;
        }
      });

      this.isActive = total > 0;
      if (!this.isActive) {
        store.commit("setNextButtonDeactive", '["questionTen"]');
      }
    },
    nextQuestion() {
      var answerArray = [];
      var activeChecked = [];
      var checkboxes = document.getElementsByName("coping[]");
      const currentURL = new URL(location.href);
      const isDemo = currentURL.searchParams.get('demo') === 'true';

      checkboxes.forEach((checkbox, i) => {
        if (checkbox.checked) {
          answerArray.push(this.answerOptions[i]);
          activeChecked[i] = checkbox.id;
        } else {
          activeChecked[i] = "NULL";
        }
      });

      answerArray = this.removeDuplicates(answerArray);

      answerArray.forEach((answer) => {
        if (!isDemo) {
        this.$gtag.event("q10-answer", {
          event_category: "answers",
          event_label: answer,
        });
      } else if(isDemo) {
        console.log("Demo Mode: no event tracking");
      }
      });

      var objectForPages = {
        index: '["questionTen"]',
        ans: answerArray,
      };

      var objectForChecked = {
        questionNum: '["questionTen"]',
        checkedButtons: activeChecked,
      };

      store.commit("addAnswer", objectForPages);
      store.commit("setNextButtonActive", '["questionTen"]');
      store.commit("setChecked", objectForChecked);
      store.commit("updatePage", '["questionThree"]');
    },

    scrollToTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },

    removeDuplicates(arr) {
      return arr.filter((item, index) => arr.indexOf(item) === index);
    },
  },
};
</script>
